import clsx from "clsx"
import React from "react"

import { BaseButton, BaseButtonProps } from "./BaseButton"

export type DeleteButtonProps = {} & Omit<BaseButtonProps, "className">

export const DeleteButton: React.FC<DeleteButtonProps> = (props) => <BaseButton {...props} className={clsx("delete")} />
